// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_iu-0";
export var actionModalContentContainer = "_iu-1";
export var createTagButton = "_iu-2";
export var footerContainer = "_iu-7";
export var fullWidthDivider = "_iu-3";
export var hasCreateTagButton = "_iu-4";
export var noCreateTagButton = "_iu-5";
export var tagsContainer = "_iu-6";
export var tagsModalContentContainer = "_iu-8";